// import { useCallback, useEffect, useRef, useState } from "react";

//components
import Card from "components/UI/Card/Card";
import CardBody from "components/UI/Card/CardBody";
import CardHeader from "components/UI/Card/CardHeader";
import CardIcon from "components/UI/Card/CardIcon";
import GridContainer from "components/UI/Grid/GridContainer";
import GridItemTS from "components/UI/Grid/GridItemTS";

// material-ui icons
import { Work } from "@material-ui/icons";

import { TitlePages } from "components/UI/TitlePage/TitlePages";

import { FormCreateWorker } from "./components/FormCreateWorker";

const WorkersCreate = () => {
  return (
    <>
      <GridContainer>
        <GridItemTS key="user-list-data" xs={12}>
          <Card>
            <CardHeader color="rose" icon>
              <CardIcon color="rose">
                <Work />
              </CardIcon>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "flex-end",
                }}
              >
                <TitlePages type="sidebar" title="workers" />
                {/* <FieldglassButton type="supplier" /> */}
              </div>
            </CardHeader>

            <CardBody>
              <FormCreateWorker />
            </CardBody>
          </Card>
        </GridItemTS>
      </GridContainer>
    </>
  );
};

export default WorkersCreate;
